import React, { useEffect, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import Checkbox from '../common/Checkbox'
import Style from 'style-it'
import SearchField from '../common/SearchField'
// import { fetchMoreDevices, searchDevices } from '../../Actions/Devices'
import Button from '../common/Button'
import { Badge, Box, Tooltip } from '@mui/material'
// import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { withTranslationWrapper } from '../../HOC'
import { FixedSizeList as List } from 'react-window'
import Loader from '../../Layout/Loader'

const DeviceSelectorList = (props) => {
  const [state, setState] = useState({
    list: {},
    others: [],
    search: '',
    isChecked: false
  })

const [activeTab, setActiveTab] = useState('all') // 'all' | 'selected'

  const [loading, setLoading] = useState(true)


const filteredDevices = useMemo(() => {
  if (!props.devicesList) return []
  let devices = props.devicesList.filter(device => {
    const label = (device.name || device.label || '').toLowerCase()
    const matchesSearch = label.includes(state.search.toLowerCase())
    const isSelected = !!state.list?.[device.id]

    if (activeTab === 'selected') {
      return isSelected && matchesSearch
    }

    return matchesSearch
  })

  if (activeTab === 'all') {
    devices.sort((a, b) => {
      const aSelected = !!state.list?.[a.id]
      const bSelected = !!state.list?.[b.id]
      return bSelected - aSelected
    })
  }

  return devices
}, [props.devicesList, state.list, activeTab, state.search])

  useEffect(() => {


    // props.dispatch(fetchMoreDevices(true, props.rows || 10))
    const list = {}
    const others = []
    if (props.value && props.value.length && props.devicesList && props.devicesList.length) {
      props.value.forEach(d => {
        const found = props.devicesList.find(dev => dev.id === parseInt(d))
        if (found) {
          list[d] = true
        } else {
          others.push(d)
        }
      })
    }
    setState((prevState) => ({ ...prevState, list, others }))
  }, [])

  useEffect(() => {
    return () => {
      setState((prevState) => ({
        ...prevState,
        list: {},
        search: '',
        isChecked: false
      }))
    }
  }, [])

useEffect(() => {
  props.onChange?.([...Object.keys(state.list), ...state.others])
}, [state.list, state.others])


  useEffect(() => {
    if (Array.isArray(props.value) && props.value?.length === 0) {
      setState((prevState) => ({ ...prevState, list: {}, isChecked: false }))
    }
  }, [props?.reportType])

useEffect(() => {
  if (!filteredDevices.length) return

  const allChecked = filteredDevices.every(d => state.list?.[d.id])
  if (state.isChecked !== allChecked) {
    setState(prev => ({ ...prev, isChecked: allChecked }))
  }
}, [filteredDevices, state.list])


  // useEffect(() => {
  //   props.dispatch(searchDevices({ device: state.search }))
  // }, [state.search])

const toggleItems = e => {
  if (e.target.checked) {
    const list = { ...state.list }
    filteredDevices.forEach(d => (list[d.id] = true))
    setState(prev => ({ ...prev, list, isChecked: true }))
  } else {
    const list = { ...state.list }
    filteredDevices.forEach(d => delete list[d.id])
    setState(prev => ({ ...prev, list, isChecked: false }))
  }
}


const onChange = (e, v) => {
  const list = { ...state.list }

  if (e.target.checked) {
    list[v.id] = true
  } else {
    delete list[v.id]
  }

  setState(prev => ({
    ...prev,
    list,
    isChecked:
      filteredDevices.length > 0 &&
      filteredDevices.every(d => list[d.id])
  }))
}


  const searchItem = text => {
    setState((prevState) => ({ ...prevState, search: text.target.value }))
  }
  useEffect(() => {
  if (props.devicesList && props.devicesList?.length > 0) {
    setLoading(false)
  }
}, [props.devicesList])



  const Row = ({ index, style }) => {
    const device = filteredDevices[index]
    return (
 <li
        style={{
          ...style,
          listStyle: 'none',
          margin: '2px 0',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
        className="selector-row"
      >
        <label
          className={state.list?.[device.id] ? 'active' : null}
          style={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            padding: '2px 2px',
            borderRadius:`4px`,
            background: props.themecolors.themeLightColor,
            color: props.themecolors.themeLightInverse,
          }}
        >
          {!props.readOnly && (
            <span className="selector-check">
              <Checkbox
                checked={state.list?.[device.id] || false}
                value={device}
                onChange={e => onChange(e, device)}
              />
            </span>
          )}
       <Tooltip title={device.name || device.label} placement="top-start">
            <span className="selector-label" style={{ flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {device.name || device.label}
            </span>
          </Tooltip>
        </label>
      </li>
    )
  }

  return (
    <Style>
      {`
        .selector-row {
          display: flex;
          align-items: center;
          height: 32px;
          border-radius: 4px;
        }

        .selector-list li > label.active,
        .selector-list li > label:hover {
          background: ${props.themecolors.themeLightColor};
          color: ${props.themecolors.themeLightInverse};
        }

        .selector-check {
          padding: 2px 4px;
        }

        .selector-label {
          font-size: 12px;
          line-height: 1.5;
          margin-left: 6px;
        }

        .selector-count {
          padding: 0 0 6px;
          font-size: 10px;
          display: flex;
          justify-content: space-between;
        }
      `}
      <div style={{ width: '100%' }}>
        {/* {props.isEvent && (
          <Tooltip title="Toggle between selected and unselected trackers">
            <Button onClick={() => setShowSelected(prev => !prev)} style={{ marginBottom: '0.5rem' }}>
              <FilterAltIcon size={14} style={{ marginRight: 6 }} />
              {showSelected ? props.translate('unselectedUnits') : props.translate('selectedUnits')}
            </Button>
          </Tooltip>
        )} */}

<Box sx={{ display: 'flex', gap: 2, justifyContent: 'space-between', mb: 2 }}>
  {['all', 'selected'].map((tab) => {
    const isActive = activeTab === tab
    const count = tab === 'all' ? props.devicesList?.length || 0 : Object.keys(state.list).length
        const bgColor =
      isActive
        ? props.themecolors.menuActiveBackground
        :props.themecolors.themeLightColor+88 

    const textColor =
      isActive
        ? props.themecolors?.id === 4
          ? props.themecolors.menuTextColor
          : 'white'
        : props.themecolors.menuActiveColor

    return (
      <Box key={tab} sx={{ flex: 1, position: 'relative' }}>
        <Button
          normal
          onClick={() => setActiveTab(tab)}
          sx={{
            borderRadius: '999px',
            // minWidth: 120,
            width: '100%',
            height: 30,
            fontWeight: 600,
            transition: 'all 0.3s ease',
          }}
          style={{
            backgroundColor:bgColor,
            color:textColor,
          }}
        >
          {tab === 'all' ? props.translate('allUnits') : props.translate('selectedUnits')}
        </Button>
    {tab === 'selected' && (
             <Badge
          badgeContent={count}
          color={isActive ? 'error' : 'default'}
          max={999}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          sx={{
            position: 'absolute',
            top: -6,
            right: 4,
            '& .MuiBadge-badge': {
              minWidth: 18,
              height: 18,
              borderRadius: '50%',
              fontSize: 10,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.3s ease',
              transform: 'scale(1)',
              backgroundColor:textColor ,
              color:bgColor
            },
          }}
        />
  )}
     
      </Box>
    )
  })}
</Box>

        <div className='section-head clearfix section-head-filter' style={{ padding: 0, marginLeft: -6, marginRight: -2 }}>
          <ul className='filter-row pull-left'>
            {props.devicesList?.length > 0 && (
              <li>
                <SearchField
                  label={props.translate('searchUnits')}
                  type='search'
                  placeholder='exp: ID, Name'
                  value={state.search}
                  onChange={searchItem}
                  variant='outlined'
                  margin='dense'
                  fullWidth
                />
              </li>
            )}
            {/* {!showSelected&& (
              <li style={{ paddingRight: 0, paddingTop: 3 }}>
                <Checkbox
                  checked={state.isChecked}
                  onChange={toggleItems}
                  label={props.translate('selectAll')}
                />
              </li>
            )} */}
               {/* {showSelected&&state.isChecked&& ( */}
              <li style={{ paddingRight: 0, paddingTop: 3 }}>
                <Checkbox
                  checked={state.isChecked}
                  onChange={toggleItems}
                  label={props.translate('selectAll')}
                />
              </li>
            {/* )} */}
          </ul>
        </div>

        {/* {!props.readOnly && !props.singleSelect && (
          <div className='selector-count'>
            <span><span style={{ marginRight: 3 }}>{Object.keys(state.list).length}</span>{props.translate('UnitsSelected')}</span>
            <span><span style={{ marginRight: 3 }}>{Object.keys(state.others).length}</span>{props.translate('more')}</span>
          </div>
        )} */}

          {loading?<Loader defaultStyle={true}/>:filteredDevices?.length > 0 ? (
            <List
              height={32 * (props.rows || 10)}
              itemCount={filteredDevices.length}
              itemSize={32}
              width="100%"
            >
              {Row}
            </List>
          ) : (
            <p style={{ textAlign: 'center', color: '#ccc' }}>{props.translate?.('notFound') || 'Not Found'}</p>
          )}
      </div>
    </Style>
  )
}

const mapState = state => ({
  devicesList: state.devices2,
  themecolors: state.themeColors,
  positions: state.positions
})

export default connect(mapState)(withTranslationWrapper(DeviceSelectorList))
